import { useState, useEffect } from "react";

import "./style.css";

const TimeCounter = ({ fromTo, time = { hour: 0, minets: 0 }, setTime }) => {
	const { hour, minets } = time;
	const [inputValue, setInputValue] = useState(hour.toString());
	const [inputMinets, setInputMinets] = useState(minets.toString());

	const increaseHours = () => { setTime((prev) => ({ ...prev, hour: (prev.hour + 1) % 24 })); };
	const decreaseHours = () => { setTime((prev) => ({ ...prev, hour: prev.hour === 0 ? 23 : prev.hour - 1, })); };

	const increaseMinets = () => { setTime((prev) => ({ ...prev, minets: (prev.minets + 1) % 60 })); };
	const decreaseMinets = () => { setTime((prev) => ({ ...prev, minets: prev.minets === 0 ? 59 : prev.minets - 1, })); };

	const handleHourChange = (e) => {
		let value = e.target.value.replace(/^0+/, ""); // Видаляємо зайві нулі
		if (value.length > 2) return; // Обмежуємо введення до 2 цифр

		setInputValue(value);

		if (value === "") {
			return;
		}

		const numValue = Number(value);
		if (!isNaN(numValue) && numValue >= 0 && numValue < 24) {
			setTime((prev) => ({ ...prev, hour: numValue }));
		}
	};

	const handleHourBlur = () => {
		if (inputValue === "") {
			setTime((prev) => ({ ...prev, hour: 0 })); // Скидаємо значення в сторі
			setInputValue("00"); // Відображаємо правильний плейсхолдер
		} else {
			setInputValue(hour < 10 ? `0${hour}` : hour.toString());
		}
	};

	const handleMinetsChange = (e) => {
		let value = e.target.value.replace(/^0+/, ""); // Видаляємо зайві нулі
		if (value.length > 2) return; // Обмежуємо введення до 2 цифр
		
		setInputMinets(value);

		if (value === "") return;

		const numValue = Number(value);
		if (!isNaN(numValue) && numValue >= 0 && numValue < 60) {
			setTime((prev) => ({ ...prev, minets: numValue }));
		}
	};

	const handleMinetsBlur = () => {
		if (inputMinets === "") {
			setTime((prev) => ({ ...prev, minets: 0 }));
			setInputMinets("00");
		} else {
			setInputMinets(minets < 10 ? `0${minets}` : minets.toString());
		}
	};

	// Оновлений useEffect, щоб уникати зайвих нулів
	useEffect(() => {
		setInputValue(hour < 10 ? `0${hour}` : hour.toString());
	}, [hour]);

	useEffect(() => {
		setInputMinets(minets < 10 ? `0${minets}` : minets.toString());
	}, [minets]);

	return (
		<div className="time-counter-wrapper">
			<div className="time-counter">
				<div className="arrows">
					<button className="arrow-button" onClick={increaseHours}>
						<svg width="18" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12.8927 11.5423L0.686493 11.5423L6.78962 0.55542L12.8927 11.5423Z" fill="#D5C2B2" />
						</svg>
					</button>
					<button className="arrow-button" onClick={decreaseHours}>
						<svg width="18" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.686565 0.0649034L12.8928 0.0649023L6.78969 11.0518L0.686565 0.0649034Z" fill="#D5C2B2" />
						</svg>
					</button>
				</div>
				<div className="time-wrapper">
					<div>
						<input
							className="time-item"
							placeholder="00"
							type="number"
							maxLength={2}
							value={inputValue}
							onChange={handleHourChange}
							onBlur={handleHourBlur}
						/>
					</div>
					<div>
						<input
							className="time-item"
							placeholder="00"
							type="number"
							maxLength={2}
							value={inputMinets}
							onChange={handleMinetsChange}
							onBlur={handleMinetsBlur}
						/>
					</div>
				</div>
				<div className="arrows">
					<button className="arrow-button" onClick={increaseMinets}>
						<svg width="18" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12.8927 11.5423L0.686493 11.5423L6.78962 0.55542L12.8927 11.5423Z" fill="#D5C2B2" />
						</svg>
					</button>
					<button className="arrow-button" onClick={decreaseMinets}>
						<svg width="18" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.686565 0.0649034L12.8928 0.0649023L6.78969 11.0518L0.686565 0.0649034Z" fill="#D5C2B2" />
						</svg>
					</button>
				</div>
			</div>
			<p className="from-to">{fromTo}</p>
		</div>
	);
};

export default TimeCounter;


